/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Virtual Key Definitions (@accedo/xdk-virtual-key) 4.2.2
* 
*******************************************************************************/
import keyboardVKey from"./keyboardVKey";const getVKey=e=>"string"==typeof e?keyboardVKey[e]:e,addVKey=(e,y,d)=>e&&(e.VKey[y]=getVKey(d));export default addVKey;